"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AdHocReview () {
        return AdHocReview;
    },
    get CycleReview () {
        return CycleReview;
    },
    get CycleReviewFormCounts () {
        return CycleReviewFormCounts;
    },
    get Review () {
        return Review;
    },
    get ReviewFormCounts () {
        return ReviewFormCounts;
    },
    get ReviewProgress () {
        return ReviewProgress;
    },
    get ReviewStatus () {
        return ReviewStatus;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewreport = require("./review-report");
const ReviewStatus = _zod.z.enum([
    "active",
    "completed",
    "closed",
    "deleted",
    "scheduled",
    "pending"
]);
const ReviewProgress = _zod.z.object({
    completedReports: _zod.z.number(),
    totalReports: _zod.z.number(),
    percentage: _zod.z.number()
});
const ReviewFormCounts = _zod.z.object({
    total: _zod.z.number(),
    unassigned: _zod.z.number()
});
const CycleReviewFormCounts = ReviewFormCounts.extend({
    threeSixty: _zod.z.number(),
    awaitingApproval: _zod.z.number(),
    adminOnlyApproval: _zod.z.number()
});
const BaseReview = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    subject: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    startDate: _utilsisomorphic.transformDate,
    adminsOnly: _zod.z.boolean().optional().default(false),
    status: ReviewStatus,
    progress: ReviewProgress,
    completeDate: _utilsisomorphic.transformDate.nullable().optional(),
    createdAt: _utilsisomorphic.transformDate.nullable().optional(),
    creator: _utilsisomorphic.transformObjectId.nullable().optional(),
    updatedAt: _utilsisomorphic.transformDate.nullable().optional(),
    updatedBy: _utilsisomorphic.transformObjectId.nullable().optional(),
    participants: _zod.z.array(_utilsisomorphic.transformObjectId),
    reports: _zod.z.array(_reviewreport.ReviewReportWithoutContent).optional()
});
const AdHocReview = BaseReview.extend({
    type: _zod.z.literal("adHoc"),
    reviewCycle: _zod.z.undefined().optional(),
    workflow: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId.nullable(),
        name: _zod.z.string()
    }),
    formCounts: ReviewFormCounts
});
const CycleReview = BaseReview.extend({
    type: _zod.z.literal("cycle"),
    reviewCycle: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    workflow: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    formCounts: CycleReviewFormCounts,
    easyAddConfigs: _zod.z.array(_utilsisomorphic.transformObjectId.nullable()).optional()
});
const Review = _zod.z.discriminatedUnion("type", [
    AdHocReview,
    CycleReview
]);
